import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

// project imports
import headerLogo from 'assets/images/logos/mybox (175 x 45 px) (140 x 40 px).png';
import loginLogo from 'assets/images/logos/mybox (175 x 45 px) (150 x 40 px).png';

// ==============================|| MY BOX LOGO ||============================== //

export default function Logo({ size = 'header', width, height, sx = {}, ...props }) {
  const theme = useTheme();
  const isDark = theme?.palette?.mode === 'dark';
  const isLogin = size === 'login';
  const logoSrc = isLogin ? loginLogo : headerLogo;

  const defaultWidth = isLogin ? 150 : 140;
  const defaultHeight = isLogin ? 40 : 40;

  const imgElement = (
    <img
      src={logoSrc}
      alt="MY BOX"
      width={width || defaultWidth}
      height={height || defaultHeight}
      style={{
        maxWidth: '100%',
        height: 'auto',
        maxHeight: isLogin ? '44px' : '40px',
        objectFit: 'contain',
        display: 'block'
      }}
      {...props}
    />
  );

  if (isDark) {
    return (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'rgba(255, 255, 255, 0.96)',
          borderRadius: '8px',
          px: '7px',
          py: '3px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
          ...sx
        }}
      >
        {imgElement}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'inline-block', ...sx }}>
      {imgElement}
    </Box>
  );
}

Logo.propTypes = {
  size: PropTypes.oneOf(['header', 'login']),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sx: PropTypes.object
};
